import { Injectable } from '@angular/core';
import { AnnouncementKind, Base, Storage, StorageBaseKeys } from '@sb/library/base';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AnnouncementService extends Base {
    private _currentAnnouncementsShown: AnnouncementKind[] = [];
    private _dismissSubject = new Subject<AnnouncementKind>();

    ShowAnnouncement(announcement: AnnouncementKind): void {
        if (!this._currentAnnouncementsShown.includes(announcement)) {
            this._currentAnnouncementsShown = [...this._currentAnnouncementsShown, announcement];
        }
        Storage.SetValue(StorageBaseKeys.CurrentAnnouncements, this._currentAnnouncementsShown);
    }

    ClearAnnouncement(announcement: AnnouncementKind): void {
        if (this.IsAnnouncementShowing(announcement)) {
            this._currentAnnouncementsShown = this._currentAnnouncementsShown.filter(current => current !== announcement);
        }
        Storage.SetValue(StorageBaseKeys.CurrentAnnouncements, this._currentAnnouncementsShown);
    }

    IsAnnouncementShowing(announcement: AnnouncementKind): boolean {
        return this.GetAnnouncementIndex(announcement) > -1;
    }

    LoadAnnouncementsFromStorage(): void {
        this._currentAnnouncementsShown = Storage.GetValue(StorageBaseKeys.CurrentAnnouncements, []);
    }

    private GetAnnouncementIndex(announcement: AnnouncementKind): number {
        const index = this._currentAnnouncementsShown.indexOf(announcement);
        return index;
    }

    get announcements(): AnnouncementKind[] {
        return this._currentAnnouncementsShown;
    }

    get dismissSubject(): Subject<AnnouncementKind> {
        return this._dismissSubject;
    }
}
